import AnalyticsBase from './AnalyticsBase';

class AdditionalServicesEvent extends AnalyticsBase {
  name: string | null;

  remove?: boolean;
}

export default AdditionalServicesEvent;
